// extracted by mini-css-extract-plugin
module.exports = {"width100":"x_dp h_dp","design3Pos":"x_sj h_dT"};